import React, { ReactElement } from 'react';
import { NextPageContext } from 'next';
import { useIntl } from 'react-intl';
import SubmitJobPostingsPageLayout
  from '@fuww/library/src/Layouts/SubmitJobPostingsPage';
import Button from '@fuww/library/src/Button';
import correctLocalizedRoute from '../lib/correctLocalizedRoute';
import messages from '../lib/messages.mjs';
import Head from '../components/Head';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import LinkAndAnchor from '../components/LinkAndAnchor';
import createCompanyBreadcrumbs from '../lib/createCompanyBreadcrumbs';
import { useSiteContext } from '../components/SiteContext';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/mJUmwU67SnGpuT347JkhWfLI16CyRh6adoXl7sZtGsw/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VibWl0LXlvdXItam9iLXBvc3RpbmdzLmpwZw',
    'https://r.fashionunited.com/QguV2K3WrAV5RSkiqLWzDOAQqFDGioudqEd_U7IWL4c/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VibWl0LXlvdXItam9iLXBvc3RpbmdzLmpwZw',
    'https://r.fashionunited.com/BNqPu_Ou23ab6_12J8YK34T5B-GKbaobtOQ2aMiYfYs/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VibWl0LXlvdXItam9iLXBvc3RpbmdzLmpwZw',
  ],
  desktop: [
    'https://r.fashionunited.com/2HgQZgL5DOhL44Qtxna3uwoImddJ_hJqDOq1gvDynjM/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VibWl0LXlvdXItam9iLXBvc3RpbmdzLmpwZw',
    'https://r.fashionunited.com/Mrjmu-Df4FV42uCduTr8bsMEkK67-kP_gm1S01iMLY0/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VibWl0LXlvdXItam9iLXBvc3RpbmdzLmpwZw',
    'https://r.fashionunited.com/iDbm7XXWEUomrc6mCW9M8VN4aVifUzI6dm_7XQeZyNk/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VibWl0LXlvdXItam9iLXBvc3RpbmdzLmpwZw',
    'https://r.fashionunited.com/3PQjipHvx7-5LAuIaautax8yYVWT3ZgzkiUPMvN2P6w/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvc3VibWl0LXlvdXItam9iLXBvc3RpbmdzLmpwZw',
  ],
};

const SubmitJobPostingsPage = () => {
  const intl = useIntl();
  const { locale } = useSiteContext();

  const breadcrumbs = createCompanyBreadcrumbs({
    intl,
    crumbRoute: `submit-job-postings.${locale}`,
    crumbLabel: intl.formatMessage(messages['submitJobPostings.header']),
  });

  return (
    <>
      <Head
        title={intl.formatMessage(messages['submitJobPostings.header'])}
        description=""
      />
      <SubmitJobPostingsPageLayout
        bodyText={(
          <div
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              // eslint-disable-next-line max-len
              __html: intl.formatMessage(messages['submitJobPostings.bodyText']),
            }}
          />
        )}
        breadcrumbs={breadcrumbs}
        button={(
          <LinkAndAnchor
            href="https://dashboard.fashionunited.com/jobs/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button variant="contained">
              {intl.formatMessage(messages['submitJobPostings.buttonLabel'])}
            </Button>
          </LinkAndAnchor>
        )}
        callToActionText={(
          <div
          // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
            // eslint-disable-next-line max-len
              __html: intl.formatMessage(messages['submitJobPostings.callToActionText']),
            }}
          />
        )}
        description={intl.formatMessage(
          messages['submitJobPostings.description'],
        )}
        title={intl.formatMessage(messages['submitJobPostings.header'])}
      />
    </>
  );
};

SubmitJobPostingsPage.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        alt="Submit job postings banner image"
        imageUrls={headerImageUrls}
      />
    )}
  >
    {page}
  </Layout>
);

SubmitJobPostingsPage.getInitialProps = (context: NextPageContext) => {
  correctLocalizedRoute(context, 'submit-job-postings');
  return {};
};

export default SubmitJobPostingsPage;
